<app-content-container>
  <div class="max-w-2xl mx-auto text-center">
    <h2 class="text-2xl font-bold text-white md:text-3xl">
      Entre na comunidade
    </h2>
    <p class="mt-4 text-base" data-testid="mentorship-community-call">
      Os temas das mentorias são escolhidos pela comunidade no grupo do
      WhatsApp. Entre, participe das discussões e ajude a escolher os próximos
      temas.
    </p>
    <a
      class="btn btn-primary mt-8"
      [href]="communityWhatsappUrl"
      target="_blank"
      rel="noopener"
      data-testid="mentorship-community-link"
    >
      Entrar no grupo da comunidade
    </a>
  </div>
</app-content-container>
